import { FETCH_GEOCODE_SUCCESS } from '../actionTypes';
import { companyGeneralActions } from '../reducer';

export default () => companyGeneralActions[FETCH_GEOCODE_SUCCESS]([]);
